export default "__VITE_ASSET__BfxxVZOf__"